module.exports = __webpack_public_path__ + "media/images/plan-grid4-12a5ee34f5dbe874f83ca2ba9454828c.jpg";